module.exports = __webpack_public_path__ + "img/hundred_green.db3f6e54.png";